import { IMenu } from 'layouts/front-layout/interfaces';

export const addChildrenToTree = (
  tree: IMenu[],
  children: IMenu[],
  link: string = '',
) => {
  tree.forEach(item => {
    if (item.id === children[0].parentId) {
      // if item is a parent use its link or if it is a child add its parent's link
      item.link = item.link ? item.link : `${link}`;
      item.children = children.map(child => {
        child.link = `${item.link}/${child.param}`;
        return child;
      });
    }
    if (item.hasChildren && item.children) {
      addChildrenToTree(item.children, children, item.link);
    }
  });
  return tree;
};
